///
/// EarthBrowser Admin Dashboard - Redux Store
///
/// Simplified store for admin dashboard - no persistence needed
///
/// Created: 2025-11-27
/// Copyright (c) 2025 Geodata Labs
///

import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { useDispatch, useSelector, useStore } from 'react-redux'
import { authenticatedApi } from './api/authenticatedApi'
import { userSlice } from './userSlice'

const rootReducer = combineReducers({
  user: userSlice.reducer,
  [authenticatedApi.reducerPath]: authenticatedApi.reducer,
})

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      immutableCheck: { warnAfter: 128 },
      serializableCheck: { warnAfter: 128 },
    }).concat(authenticatedApi.middleware)
  },
})

setupListeners(store.dispatch)

export type AppStore = typeof store
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']

export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()
export const useAppStore = useStore.withTypes<AppStore>()

